import axios, { AxiosResponse, AxiosError } from 'axios';
import NoviLogging from "@/common/services/NoviLogging";
import { INoviNsPaymentGlobals } from '../../common/types/Payment/NoviNsPaymentGlobals';

declare let noviNs: INoviNsPaymentGlobals;

class FiservRepo {
    getFiservPaymentToken(data: any) {
        const tokenizeUrl = `https://${noviNs.fiservSubdomainSite}.cardconnect.com/cardsecure/api/v1/ccn/tokenize`;

        return axios.post<{ token: string }>(tokenizeUrl, data)
            .then((axiosResponse: AxiosResponse<{ token: string }>) => {
                return axiosResponse.data.token;
            })
            .catch((axiosError: AxiosError) => {
                // PCI: never log the request body — it contains the PAN and CVV.
                // Only transport-level metadata is safe to log, and it is what we need
                // to tell a network/CORS/CSP/DNS failure (no response) apart from an
                // HTTP error returned by CardSecure (response present with a status).
                NoviLogging.error('Fiserv CardSecure tokenize request failed', {
                    url: tokenizeUrl,
                    fiservSubdomainConfigured: !!noviNs.fiservSubdomainSite,
                    message: axiosError?.message,
                    code: axiosError?.code,
                    hasResponse: !!axiosError?.response,
                    httpStatus: axiosError?.response?.status ?? null,
                    responseData: axiosError?.response?.data ?? null,
                });
                throw axiosError;
            });
    }
}

export const fiservRepo = new FiservRepo();